import { render, staticRenderFns } from "./JobDialog.vue?vue&type=template&id=2484299e&scoped=true"
import script from "./JobDialog.vue?vue&type=script&lang=js"
export * from "./JobDialog.vue?vue&type=script&lang=js"
import style0 from "./JobDialog.vue?vue&type=style&index=0&id=2484299e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484299e",
  null
  
)

export default component.exports